// @flow
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { lineColor } from '../../styles/style-constants';

type Props = {
  name: string,
  style: Object,
  filled: Boolean,
  classes: Object
}

const anchorClasses = (classes, filled) => {
  if (filled) { return classes.lineAnchorFilled; }
};

const LineAnchor = ({ name, classes, style, filled, className }: Props) => {
  return (
    <div className={`${name} ${anchorClasses(classes, filled)} ${classes.lineAnchor} ${className}`} style={style} />
  );
};

const styles = {
  lineAnchorFilled: {
    borderRadius: '50%',
    paddingLeft: '-24px',
    backgroundColor: lineColor
  },
  lineAnchor: {
    width: 16,
    height: 16,
    display: 'inline-block',
    margin: 0,
    padding: 0
  }
};

export default withStyles(styles)(LineAnchor);



// WEBPACK FOOTER //
// ./src/components/core/LineAnchor.js